/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type DashboardsDirectoryType from '@jira/spa-apps__directories-dashboards/src/DashboardsDirectoryType.tsx';
import type { DashboardDirectoryEntryPointProps } from '@jira/spa-apps__directories-dashboards/src/DashboardDirectoryEntryPoint.entrypoint.types.tsx';
import type { EntryPointProps, EntryPoint } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyDashboardsDirectory: LazyComponent<
	(
		props: EntryPointProps<
			Record<string, OperationType>,
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			Record<string, EntryPoint<any, any> | undefined>,
			DashboardDirectoryEntryPointProps,
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			Record<any, any> | null
		>,
	) => React.JSX.Element
> = lazyForPaint<typeof DashboardsDirectoryType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-dashboards-directory", jiraSpaEntry: "async-dashboards-directory" */ '@jira/spa-apps__directories-dashboards/src/DashboardsDirectoryType.tsx'
		),
	),
);

export const DashboardsDirectoryComponent = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDashboardsDirectory}
		pageId="dashboards-directory"
		shouldShowSpinner={false}
	/>
);
